import React from "react"
import {GameMode,
  Index,
  List,
  ListItem,
  Rule,
  RulesListContainer} from "./styled"
import { skin } from "../../../styles/skin"

const RulesList = ({
  className,
  gameMode,
  rules,
  fontColor,
  bgColor,
  hasEvenlyRoundedCorners,
  fonts
}) => (
  <RulesListContainer
    bgColor={bgColor}
    className={className}
    fontColor={fontColor}
    fontName={fonts.secondaryFont}
    hasEvenlyRoundedCorners={hasEvenlyRoundedCorners}
  >
    <GameMode>
      { gameMode.toUpperCase() }
    </GameMode>
    <List>
      {
        rules.map((rule, i) => (
          <ListItem key={rule}>
            <Index>
              { `${i + 1}. ` }
            </Index>
            <Rule>
              { rule }
            </Rule>
          </ListItem>
        ))
      }
    </List>
  </RulesListContainer>
)

RulesList.defaultProps = {
  bgColor: "#ffffff",
  fontColor: "#0F1635",
  gameMode: "Punkte",
  rules: [
    "Der Spieler mit der höchsten Punktzahl am Ende gewinnt.",
    "Für richtige Antworten erhält der Spieler Punkte. Je schneller die Antwort, umso mehr Punkte gibt es.",
    "Ist die Antwort falsch, werden die Punkte abgezogen. Auch hier gilt: je schneller die Antwort, desto größer der Punktabzug.",
    "Wird keine Antwort ausgewählt, werden weder Punkte verdient noch abgezogen... spielt strategisch!",
  ],
}

export default RulesList
